import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { GeneralTasksStore } from '../stores/generalTasksStore';

export const useGeneralTasksStore = () =>
  useContext<{
    generalTasksStore: GeneralTasksStore;
  }>(StoreContext);
